import clsx from 'clsx';
import React from 'react';

import { EmployeeSearchItemProps } from './interfaces';

const EmployeeSearchItem = React.forwardRef<HTMLButtonElement, EmployeeSearchItemProps>(
  (props, ref) => {
    const { employee, allEmployees, onSelectPath, isHighlighted, onMouseEnter, path } = props;

    const getBreadcrumbTitles = () => {
      if (!path || path.length <= 1) return null;

      // Get all employees in the path except the current employee (last in path)
      const pathEmployees = path
        .slice(0, -1)
        .map((id) => allEmployees.find((emp) => emp.id === id))
        .filter(Boolean);

      if (pathEmployees.length === 0) return null;

      // Highest rank first
      return pathEmployees.map((emp) => emp.title).reverse();
    };

    const breadcrumbTitles = getBreadcrumbTitles();

    return (
      <button
        ref={ref}
        className={clsx(
          'group w-full cursor-pointer appearance-none border-0 p-16 text-left',
          isHighlighted
            ? 'bg-primary-magenta text-white'
            : 'bg-white hover:bg-primary-magenta dark:bg-[var(--light-grayscale-charcoal)] dark:hover:bg-primary-pink'
        )}
        onClick={onSelectPath}
        onMouseEnter={onMouseEnter}
      >
        <p
          className={clsx(
            'm-0 text-caption-lg leading-none',
            isHighlighted ? 'text-white' : 'group-hover:text-white'
          )}
        >
          {employee.name}
        </p>
        <span
          className={clsx(
            'm-0 text-caption-sm leading-none',
            isHighlighted ? 'text-white' : 'text-grayscale-gray group-hover:text-white'
          )}
        >
          {employee.title}
        </span>

        {breadcrumbTitles && breadcrumbTitles.length > 0 && (
          <div
            className={clsx(
              'mt-1 !text-caption-sm leading-none',
              isHighlighted ? 'text-white' : 'text-grayscale-gray group-hover:text-white'
            )}
          >
            <span
              className={clsx(
                isHighlighted ? 'text-white' : 'text-primary-magenta group-hover:text-white'
              )}
            >
              Reports to:{' '}
            </span>
            {breadcrumbTitles.map((title, index) => (
              <span key={index}>
                <span className={clsx(isHighlighted ? 'text-white' : '')}>{title}</span>
                {index < breadcrumbTitles.length - 1 && (
                  <span
                    className={clsx(
                      'mx-1',
                      isHighlighted ? 'text-white' : 'text-primary-magenta group-hover:text-white'
                    )}
                  >
                    {' '}
                    &gt;{' '}
                  </span>
                )}
              </span>
            ))}
          </div>
        )}
      </button>
    );
  }
);

EmployeeSearchItem.displayName = 'EmployeeSearchItem';
export default EmployeeSearchItem;
